"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicinalProduct_ManufacturingBusinessOperation = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Reference_1 = require("./RTTI_Reference");
exports.RTTI_MedicinalProduct_ManufacturingBusinessOperation = t.recursion('IMedicinalProduct_ManufacturingBusinessOperation', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        operationType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        authorisationReferenceNumber: RTTI_Identifier_1.RTTI_Identifier,
        effectiveDate: RTTI_dateTime_1.RTTI_dateTime,
        _effectiveDate: RTTI_Element_1.RTTI_Element,
        confidentialityIndicator: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        manufacturer: t.array(RTTI_Reference_1.RTTI_Reference),
        regulator: RTTI_Reference_1.RTTI_Reference
    });
});
//# sourceMappingURL=RTTI_MedicinalProduct_ManufacturingBusinessOperation.js.map